import { CommonModule, CurrencyPipe } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatRadioModule } from '@angular/material/radio';
import { OrderItem, ShippingRateOption,   } from '../../../../globalTypes/order.types';
import { ShippingService } from '../../services/shipping.service';
import { httpsCallable, HttpsCallableResult } from 'firebase/functions';
import { Functions } from '@angular/fire/functions';
import { OrderService } from '../../services/order.service';
import { LoadingLogoComponent } from "../layout/element/loading-logo.component";
import { onCallFunctions } from '../../../../globalTypes/backend.api.types';
import { Rate } from 'shippo';
import { CART_BUNDLE_MODE } from '../../../../globalTypes/configs';
import { addShippingRateToOrderItemVariables } from '../../../../globalTypes/onCall.types';
import { ListingService } from '../../services/listing.service';

@Component({
  selector: 'msh-checkout-rate-selector',
  imports: [MatRadioModule, FormsModule, CommonModule, CurrencyPipe, LoadingLogoComponent],
  template: `
   
<div class="text-lg text-center mt-12 mb-6">Shipping Options</div>
@if(gettingShippingRates){
  <div class="null ">
    Retrieving shipping rate options from available providers
    <msh-loading-logo class="w-96 h-96 block m-auto"></msh-loading-logo>
  </div>
} @else if( shippingLotIds.length > 0){
  @for(shippingLotId of shippingLotIds; track shippingLotId){
    @if(fixedShippingRates[shippingLotId] && fixedShippingRates[shippingLotId].items && fixedShippingRates[shippingLotId].items.length > 0){
      <div class="flex gap-4 flex-wrap min-w-16 mb-12 border rounded-md p-4 justify-around items-center">
        @for(item of fixedShippingRates[shippingLotId].items; track item.id){        
          <div class="">
            <ng-container [ngTemplateOutlet]="itemTemplate" [ngTemplateOutletContext]="{item}"></ng-container>
          </div>
          <div>
            {{fixedShippingRates[shippingLotId].fixedText}}
          </div>
        }
      </div>
    }
    @if(shippingRates[shippingLotId] && shippingRates[shippingLotId].items && shippingRates[shippingLotId].items.length){
      <div class="flex gap-4 flex-wrap min-w-16 mb-12 border rounded-md p-4 justify-around items-center">
        <div class="">
        @for(item of shippingRates[shippingLotId].items; track item.id){
          <ng-container [ngTemplateOutlet]="itemTemplate" [ngTemplateOutletContext]="{item}"></ng-container>
        }
        </div>
        <div>
          @if(shippingRates[shippingLotId].rate; as rate){
            <div class="flex gap-2 justify-between cursor-pointer">
              <img class=" h-10" [src]="rate.providerImage200" />
              <div>
                <div class="flex gap-2">
                  <div>{{rate.provider}}</div>
                  <div>{{rate.amount | currency}}</div>
                  <div>{{rate.servicelevel.name}}</div>
                </div>
                <div class="text-xs max-w-80">{{rate.durationTerms }}</div>
              </div>
            </div>
            <div class="lil-action mt-3" (click)="shippingRateToBeReselected(shippingLotId)">reselect from options</div>
          } @else { 
            @if(shippingRates[shippingLotId].rates; as rates){
              @if(ratesLoading[shippingLotId]){<msh-loading-logo class=" w-40 h-40 block m-auto"></msh-loading-logo>}
              <mat-radio-group [class]=" (ratesLoading[shippingLotId] ? 'opacity-50' : '')+' flex flex-col gap-6'" (ngModelChange)="shippingRateSelected({rateId: $event, shippingLotId})" [(ngModel)]="shippingRates[shippingLotId].selectedRateId">
              @for(rate of rates; track rate.objectId){
                @if(rate.attributes.length || showMoreRates[shippingLotId]){
                  <mat-radio-button class="" [value]="rate.objectId">
                    <div class="flex gap-2 justify-between cursor-pointer">
                      <img class=" h-10" [src]="rate.providerImage200" />
                      <div>
                        <div class="flex gap-2">
                          <div>{{rate.provider}}</div>
                          <div>{{rate.amount | currency}}</div>
                          <div>{{rate.servicelevel.name}}</div>
                        </div>
                        <div class="text-xs max-w-80">{{rate.durationTerms }}</div>
                      </div>
                    </div>
                  </mat-radio-button>
                }
              }
              </mat-radio-group>
              @if(rates && rates.length > 3){
                <div class="text-center mt-4">
                  <div class="lil-action" (click)="showMoreRatesFunc(shippingLotId)">{{showMoreRates[shippingLotId] ? 'Show less' : 'Show more options'}}</div>
                </div>
              }
            } 
            @if(shippingRates[shippingLotId].rates && shippingRates[shippingLotId].rates.length === 0){
              <div class="null">
                No shipping options available for this item.  Please contact the seller to resolve.
              </div>
            }
          }
        </div>
      </div>
    }
  }
}
<ng-template #itemTemplate let-item="item">
  <div class="w-16 bg-white h-16 bg-back flex justify-center items-center mr-6 rounded overflow-hidden shadow-lg">
    <img [src]="item.listingVariation.image.url" />
  </div>
  <div class="font-bold">

    @if(item.listingVariation && item.listingVariation.listing && item.listingVariation.listing.name){
      {{item.listingVariation.listing.name}}
      @if(item.listingVariation.name && item.listingVariation.listing.name !== item.listingVariation.name){
        <span class="font-normal">- {{item.listingVariation.name}}</span>
      }
    }
  </div>
  <div class="text-sm">{{item.listingVariation.description}}</div>
  <div class="">{{item.listingVariation.description}}</div>
</ng-template>
  `,
  styles: ``
})
export class CheckoutRateSelectorComponent implements OnChanges {
  @Input() orderItems!: (OrderItem & {shippingRateOptions?: Rate[]})[];
  @Input() orderId?: string;
  @Input() locationId!: string;
  @Output() shippingSelectedChanged = new EventEmitter<{rateId:string, shippingLotId: string}>();
  shippingLotIds: string[] = [];
  showMoreRates: {[shippingLotId:string]: boolean} = {};
  ratesLoading: {[shippingLotId:string]: boolean} = {};
  fixedShippingRates: {[shippingLotId:string]: {items:OrderItem[], fixedText: string}} = {};
  shippingRates: {[shippingLotId:string]: {items: OrderItem[], rates?:Rate[], rate?: ShippingRateOption, selectedRateId?: string}} = {};
  gettingShippingRates = false;
  currentlyHydratingCart = false;
  saveCurrentOptions: {[orderItemId:string]: Rate[]} = {};
  constructor(
    private shippingService: ShippingService,
    private listingService: ListingService,
    private functions: Functions,
    private orderService: OrderService,
  ){}

  async ngOnChanges(){
    if(!this.orderId || !this.orderItems || !this.locationId) return;
    // establish that it needs rates retrieved before calling for them
    this.fixedShippingRates = {};
    this.orderItems.forEach(item=>{
      const shippingLotId = item.fulfillmentId || ( CART_BUNDLE_MODE === "fulfillment" ? item.fulfilledByLocationId : item.id);
      if(!this.shippingLotIds.includes(shippingLotId)) this.shippingLotIds.push(shippingLotId);
      if(!this.shippingRates[shippingLotId]) {this.shippingRates[shippingLotId] = {items: [], rates: []};}
      if(item.fixedShippingCost !== undefined && item.fixedShippingCost !== null){
        if(!this.fixedShippingRates[shippingLotId]) this.fixedShippingRates[shippingLotId] = {items: [], fixedText: ''};
        this.fixedShippingRates[shippingLotId].items.push(item);
        this.fixedShippingRates[shippingLotId].fixedText = this.listingService.getShippingCostText(item.listingVariation.listing, item.quantity === 1) || 'Error loading shipping cost';
        return;
      }
      if(!this.shippingRates[shippingLotId].items.find(i=>i.id === item.id)) {
        this.shippingRates[shippingLotId].items.push(item);
      }
      if(item.rateId && !this.shippingRates[shippingLotId].rate) {
        this.shippingRates[shippingLotId].rate = {
          objectId: item.rateId,
          amount: (item.rateCharged || 0),
          provider: item.rateProviderName || '',
          providerImage200: item.rateProviderImg || '',
          servicelevel: {
            name: item.rateName || '',
          },
          durationTerms: item.rateMsg || '',
        }
      }
      // if(this.shippingRates[shippingLotId].rates) return;
    })
    console.log({shippingRates: this.shippingRates, shippingLotIds: this.shippingLotIds})
    const needsRates = Object.values(this.shippingRates).some(i=>i.rates?.length === 0 );
    console.log({needsRates, currentlyHydratingCart: this.currentlyHydratingCart})
    if(!needsRates || this.currentlyHydratingCart) {
      this.currentlyHydratingCart = false;
      setTimeout(async ()=>{ // timeout might be overkill..
        console.log({orderItems: this.orderItems})
        // this.orderItems.forEach(item=>item.shippingRateOptions = this.saveCurrentOptions[item.id]);
      }, 0)
      return
    };
    this.getShippingOptions();
    
  }

  async shippingRateToBeReselected(shippingLotId: string){
    this.shippingRates[shippingLotId].rate = undefined;
    this.shippingRates[shippingLotId].selectedRateId = undefined;
    this.shippingSelectedChanged.emit({rateId: '', shippingLotId})
    if(this.shippingRates[shippingLotId].rates && this.shippingRates[shippingLotId].rates.length > 0) return;
    this.getShippingOptions(shippingLotId);
  }

  showMoreRatesFunc(shippingLotId: string){
    this.showMoreRates[shippingLotId] = !this.showMoreRates[shippingLotId]
  }
  
  async getShippingOptions(onlyShippingLotId?: string){
    if( !this.orderId) return;
    if(onlyShippingLotId){
      this.ratesLoading[onlyShippingLotId] = true;
    } else {
      this.gettingShippingRates = true;
    }
    const rates: {[shippingLotId: string]:Rate[]} = await this.shippingService.getRatesForOrder(this.orderId, onlyShippingLotId)
    console.log({rates})
    Object.keys(this.shippingRates).forEach((key)=>{
      const shippingRate = this.shippingRates[key];
      const rateOptions = rates[key]
      shippingRate.rates = rateOptions || [];
    })
    console.log({shippingRates: this.shippingRates})
    this.gettingShippingRates = false;
    if(onlyShippingLotId)  this.ratesLoading[onlyShippingLotId] = false;
  }

  async shippingRateSelected(selection: {rateId:string, shippingLotId: string}){
    const {rateId, shippingLotId} = selection;
    if(!this.orderId) return;
    console.log({rateId, shippingLotId})
    this.currentlyHydratingCart = true;
    const fId = this.orderItems[0].rateId;
    const vars: addShippingRateToOrderItemVariables = {
      orderId: this.orderId,
      orderItemIds: this.shippingRates[shippingLotId].items.map(i=>i.id),
      shippoRateId:rateId,
    }
    this.shippingRates[shippingLotId].rate = this.shippingRates[shippingLotId].rates?.filter(r=>r.objectId === rateId).map(r=>({
      objectId: r.objectId,
      amount: r.amount,
      provider: r.provider,
      providerImage200: r.providerImage200,
      servicelevel: r.servicelevel,
      durationTerms: r.durationTerms,
    })
  )[0] as unknown as ShippingRateOption;
    // we wouldn't know the selected rate id yet because that is a db thing, not a shippo thing - this.shippingRates[shippingLotId].selectedRateId = rateId;
    console.log({vars})
    // also save shipping cost...
    const callable = httpsCallable(this.functions,  onCallFunctions.addShippingRateToOrderItem);
    const results: HttpsCallableResult = await callable(vars)
    console.log({results})
    const orderId = this.orderId
    this.saveCurrentOptions = this.orderItems.reduce((a,c)=>{
      a[c.id] = c.shippingRateOptions || []
      return a;
    },{} as {[orderItemId:string]: Rate[]})
    await this.orderService.hydrateCart(orderId, this.locationId)
    setTimeout(()=>{this.shippingSelectedChanged.emit({rateId, shippingLotId})}, 500)
  }

}
